export enum CouponBoxState {
    Closed = 1,
    Opened = 2,
    Hide = -1,
}